/* HDD 渲染劵列表 */
import { useEffect, useState } from 'react';
import { inject, observer } from 'mobx-react';

import RenderingCouponsList from '&/pages/rendering-voucher/renderingCouponsList';
import { getUserInfo } from '@/api/Dialogs/signUpDlg';
import usePreventDefault from '@/utils/customHooks/usePreventDefault';
import './index.scss';

function RenderingCouponsModal(props) {
    const { appStore, location } = props;
    const params = new URLSearchParams(location.search);
    const token = params.get('token');
    const from = params.get('from');
    usePreventDefault();
    const [userInfo, setUserInfo] = useState({});

    useEffect(() => {
        init();
    }, []);

    const init = async () => {
        if (token) {
            appStore.setLoginData({ token }, false);
            await queryUserInfo();
        }
    };
    const queryUserInfo = async () => {
        try {
            const res = await getUserInfo();
            setUserInfo(res.data);
            localStorage.setItem('HDDUserData', JSON.stringify(res.data));
        } catch (e) {}
    };
    const buyNow = renderData => {
        try {
            const url = `${window.location.origin}/hdd/buyRenderingCoupons`;
            const urlParams = `?token=${token}&render=${JSON.stringify(
                renderData
            )}${from ? `&from=${from}` : ''}`; // 传入from参数
            console.log('url', url + urlParams);
            const sendData = {
                Url: `${url}${urlParams}`,
                Width: 800,
                Height: 533,
            };
            window.external.DispatchFun(
                'StartPage',
                'ReloadUrl',
                JSON.stringify(sendData)
            );
        } catch (e) {
            console.log(e);
        }
    };

    const closeHddModal = () => {
        if (from === 'hddStartPage') {
            const sendData = {
                Url: `${window.location.origin}/hdd/myRenderingCouponsModal?token=${token}`,
                Width: 1000,
                Height: 560,
            };

            window.external.DispatchFun(
                'StartPage',
                'ReloadUrl',
                JSON.stringify(sendData)
            );
        } else {
            window.external.DispatchFun('StartPage', 'CloseRender', '');
        }
    };

    return (
        <div className="rendering-coupons-modal">
            <div className="modal-header">
                <h3>{intl.get('rendering.buyRenderingCoupons')}</h3>
                <i className="icon-close filled" onClick={closeHddModal} />
            </div>
            <div className="modal-content">
                <RenderingCouponsList buyCoupons={buyNow} userInfo={userInfo} />
            </div>
        </div>
    );
}
export default inject('appStore')(observer(RenderingCouponsModal));
